import { api } from '../DefaultService';
import {
  IAlarmCentralCreateProps,
  IAlarmCentralSimpleProps,
  IAlarmCentralUpdateParams,
} from './types';
import { IPaginationParams } from '../types';
import { IOutputsProps, IUpdateOutputsParams } from './Virtual/types';

export const ENDPOINT_ALARM_CENTRAL = 'v1/alarmCentral';
export const ENDPOINT_ALARM_CENTRAL_EVENT = 'v1/alarmCentral/events';

export const createAlarmCentralAsync = async (
  data: IAlarmCentralCreateProps,
): Promise<void> => {
  const response = await api.post(ENDPOINT_ALARM_CENTRAL, data);
  return response.data;
};

export const getAlarmCentralByIdAsync = async (id: number) => {
  return await api
    .get(`${ENDPOINT_ALARM_CENTRAL}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllAlarmCentralsByLicenseAsync = async (
  pagination?: IPaginationParams,
): Promise<IAlarmCentralSimpleProps[]> => {
  return await api
    .get<IAlarmCentralSimpleProps[]>(
      `${ENDPOINT_ALARM_CENTRAL}/getAllByLicense`,
      {
        params: { ...pagination },
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllAlarmCentralsByLicenseCountAsync =
  async (): Promise<number> => {
    return await api
      .get(`${ENDPOINT_ALARM_CENTRAL}/getAllByLicense/count`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const updateAlarmCentralByIdAsync = async ({
  id,
  data,
}: IAlarmCentralUpdateParams) => {
  return await api
    .put(`${ENDPOINT_ALARM_CENTRAL}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteAlarmCentralByIdAsync = async (id: number) => {
  await api.delete(`${ENDPOINT_ALARM_CENTRAL}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getAllAlarmCentralEventByLicenseCountAsync =
  async (): Promise<number> => {
    return await api
      .get(`${ENDPOINT_ALARM_CENTRAL_EVENT}/getAllByLicense/count`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const getAllAlarmCentralEventByIdCountAsync = async (
  id: number,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT_ALARM_CENTRAL}/${id}/events/count`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateOutputsOfAlarmCentralId = async ({
  alarmCentralId,
  outputs,
}: IUpdateOutputsParams): Promise<void> => {
  try {
    await api.put(
      `${ENDPOINT_ALARM_CENTRAL}/${alarmCentralId}/outputs`,
      outputs,
    );
  } catch (error) {
    throw new Error(
      'Erro ao atualizar as formas de notificação desta central.',
    );
  }
};

export const getOutputsOfAlarmCentralId = async (
  alarmCentralId: number,
): Promise<IOutputsProps> => {
  try {
    const response = await api.get(
      `${ENDPOINT_ALARM_CENTRAL}/${alarmCentralId}/outputs`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      'Erro ao resgatar as formas de notificações desta central.',
    );
  }
};
